import gql from 'graphql-tag';

export default gql`
  query Query($vodVideoPlayInfoId: String!, $holderId: String, $holderType: VodHolderType) {
    vodVideoPlayInfo(id: $vodVideoPlayInfoId, holderId: $holderId, holderType: $holderType) {
      id
      status
      title
      description
      coverUrl
      duration
      playList {
        definition
        width
        height
        size
        playUrl
        format
      }
    }
    vodOptions {
      videoPlayDefinitions {
        value
        label
      }
      videoStatuses {
        label
        value
      }
    }
  }
`;
